import React, { useState, useEffect } from 'react';
import { useHistory, Link, useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import GoogleMapReact from 'google-map-react';

import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { green, red } from '@material-ui/core/colors';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import CardContent from '@material-ui/core/CardContent';
import { Alert, AlertTitle } from '@material-ui/lab';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';

import stopMarkerIcon from './../../../assets/images/maps/ic_stop.png';

import StopsService from './../../../services/api/stops';

const useStyles = makeStyles({
  table: {
    marginTop: '10px',
  },
  cardContent: {
    padding: '0px !important',
  },
  card: {
    marginTop: '1rem',
  },
  chipActive: {
    backgroundColor: green[100],
    color: green[700],
  },
  chipInactive: {
    backgroundColor: red[100],
    color: red[700],
  },
  select: {
    width: '100%',
    // marginTop: '1em',
    // marginBottom: '1em',
  },
  clientSelect: {
    marginBottom: '12px',
  },
});

const RedButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
}))(Button);

const GreenButton = withStyles((theme) => ({
  root: {
    color: 'white',
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
}))(Button);

export const StopsEdit = () => {
  const classes = useStyles();
  let history = useHistory();

  let { stopId } = useParams();

  const [center, setCenter] = React.useState({
    lat: 29.0836781,
    lng: -110.959494,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [requestError, setRequestError] = useState({
    error: false,
    errorDescription: null,
  });

  const [stop, setStop] = useState({
    latitude: 'a',
    longitude: 'as',
  });

  let stopSchema = yup.object().shape({
    name: yup.string().required(),
    description: yup.string(),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
    status: yup.boolean().required(),
    companyId: yup.number(),
  });

  const { handleSubmit, errors, control, setValue, reset, register } = useForm({
    validationSchema: stopSchema,
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    setRequestError({ error: false, errorDescription: null });

    setTimeout(function () {
      //Request
      StopsService.update(stopId, data)
        .then((response) => {
          if (response === null) {
            throw new Error('Request error');
          }
          if (response.IsValid && response.Data !== undefined) {
            history.push(`/stops/detail/${response.Data.ParadaID}`);
          } else {
            throw response.Message;
          }
        })
        .catch((e) => {
          console.log(e);
          setRequestError({
            error: true,
            errorDescription: e.status ? e.data.Message : e,
          });
          setIsLoading(false);
        });
    }, 500);
  };

  const handleStatusChange = (event) => {
    setValue('status', event.target.value);
    setStop({ ...stop, status: event.target.value });
  };

  const handleCancelClick = () => {
    console.log('CancelClick');
    // props.modalStatusHandler();
  };

  const handleMapLoaded = (map, maps) => {
    var imageGoing = {
      url: stopMarkerIcon,
      // This marker is 20 pixels wide by 32 pixels high.
      size: new maps.Size(26, 26),
      scaledSize: new maps.Size(26, 26),
    };

    let markerOriginal;

    markerOriginal = new maps.Marker({
      map: map,
      draggable: false,
      icon: imageGoing,
      // animation: maps.Animation.DROP,
      position: { lat: center.lat, lng: center.lng },
    });

    let marker;
    maps.event.addListener(map, 'click', function (event) {
      markerOriginal.setMap(null);
      if (marker != null) {
        marker.setMap(null);
      }

      marker = new maps.Marker({
        map: map,
        draggable: true,
        icon: imageGoing,
        // animation: maps.Animation.DROP,
        position: { lat: event.latLng.lat(), lng: event.latLng.lng() },
      });

      setStop({
        ...stop,
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      });

      setValue('latitude', event.latLng.lat());
      setValue('longitude', event.latLng.lng());

      maps.event.addListener(marker, 'dragend', function () {
        setStop({
          ...stop,
          latitude: marker.getPosition().lat(),
          longitude: marker.getPosition().lng(),
        });

        setValue('latitude', marker.getPosition().lat());
        setValue('longitude', marker.getPosition().lng());
      });
    });

    //Fit Boundaries
    // var bounds = new maps.LatLngBounds();
    // for (let marker of markersGo) {
    //   bounds.extend(new maps.LatLng(marker.lat, marker.lng));
    // }
    // map.fitBounds(bounds);
    // }
  };

  useEffect(() => {
    setIsLoading(true);

    setTimeout(function () {
      //Request
      StopsService.get(stopId)
        .then((response) => {
          if (response === null || !response.IsValid) {
            throw response.Message;
          }

          //Get Routes
          if (response && response.Data !== undefined) {
            setStop({
              id: response.Data.ParadaID,
              name: response.Data.Nombre,
              description: response.Data.Descripcion,
              latitude: response.Data.Latitud,
              longitude: response.Data.Longitud,
              status: response.Data.EstaActivo,
              companyId: response.Data.ClienteCiudadID,
            });
            setCenter({
              lat: parseFloat(response.Data.Latitud),
              lng: parseFloat(response.Data.Longitud),
            });

            reset({
              name: response.Data.Nombre ? response.Data.Nombre : '',
              description: response.Data.Descripcion
                ? response.Data.Descripcion
                : '',
              latitude: response.Data.Latitud
                ? parseFloat(response.Data.Latitud)
                : '',
              longitude: response.Data.Longitud
                ? parseFloat(response.Data.Longitud)
                : '',
              companyId: response.Data.ClienteCiudadID
                ? response.Data.ClienteCiudadID
                : '',
              status: response.Data.EstaActivo
                ? response.Data.EstaActivo
                : false,
            });

            setIsLoading(false);
          }
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }, 500);
  }, [stopId]);

  return (
    <React.Fragment>
      <Card className={classes.card} style={{ background: '#f4f6f8' }}>
        <CardContent>
          <form
            className={classes.form}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            {isLoading ? (
              <Skeleton count={5} height={50} />
            ) : (
              <React.Fragment>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignContent="center"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item xs>
                    <input
                      type="hidden"
                      readOnly
                      name="companyId"
                      value={stop.companyId}
                      ref={register}
                    />
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="name"
                      defaultValue=""
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      required
                      id="name"
                      label="Nombre de la Parada"
                      autoComplete="name"
                      autoFocus
                      error={errors.name ? true : false}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignContent="center"
                  alignItems="flex-start"
                  justifyContent="space-between"
                  style={{ marginTop: '5px' }}
                >
                  <Grid item sm={3} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: false }}
                      name="description"
                      defaultValue=""
                      variant="outlined"
                      margin="none"
                      fullWidth
                      id="description"
                      label="Descripción de la Parada"
                      autoComplete="description"
                      error={errors.description ? true : false}
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <Controller
                      as={
                        <FormControl
                          variant="outlined"
                          className={classes.select}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Estado
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            autoWidth
                            value={stop.status}
                            onChange={handleStatusChange}
                            label="Estado"
                          >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                          </Select>
                        </FormControl>
                      }
                      className={classes.select}
                      name="status"
                      control={control}
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="latitude"
                      defaultValue=""
                      variant="outlined"
                      margin="none"
                      fullWidth
                      required
                      id="latitude"
                      label="Latitud"
                      autoComplete="latitude"
                      error={errors.latitude ? true : false}
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <Controller
                      as={<TextField />}
                      control={control}
                      rules={{ required: true }}
                      name="longitude"
                      defaultValue=""
                      variant="outlined"
                      margin="none"
                      fullWidth
                      required
                      id="longitude"
                      label="Longitud"
                      autoComplete="longitude"
                      error={errors.longitude ? true : false}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  direction="row"
                  alignContent="center"
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <Grid item xs>
                    <div
                      style={{
                        height: '350px',
                        minHeight: '350px',
                        width: '100%',
                        marginTop: '10px',
                        marginBottom: '10px',
                      }}
                    >
                      <GoogleMapReact
                        draggable={true}
                        bootstrapURLKeys={{
                          key: process.env.REACT_APP_MAPS_KEY,
                        }}
                        defaultCenter={center}
                        defaultZoom={12}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({ map, maps }) =>
                          handleMapLoaded(map, maps)
                        }
                      ></GoogleMapReact>
                    </div>
                  </Grid>
                </Grid>

                <Grid container spacing={1} direction="row" justifyContent="flex-end">
                  <Grid item>
                    <RedButton
                      component={Link}
                      to={`/stops/detail/${stop.id}`}
                      variant="contained"
                      color="secondary"
                      size="large"
                      className={classes.button}
                      startIcon={<CancelIcon />}
                    >
                      Cancelar
                    </RedButton>
                  </Grid>
                  <Grid item>
                    <GreenButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.button}
                      startIcon={<SaveIcon />}
                    >
                      Guardar Cambios
                    </GreenButton>
                  </Grid>
                </Grid>
                {requestError.error && (
                  <Grid
                    container
                    spacing={1}
                    direction="row"
                    justifyContent="flex-end"
                  >
                    <Grid item xs>
                      <Alert severity="error">
                        <AlertTitle>Algo salió mal</AlertTitle>
                        {requestError.errorDescription}
                      </Alert>
                    </Grid>
                  </Grid>
                )}
              </React.Fragment>
            )}
          </form>
        </CardContent>
      </Card>
    </React.Fragment>
  );
};
